import { makeRequest } from '../../../api/makeRequest';

export const getFamilyChildData = () => makeRequest({
  url: '/customers/products/mobile/profile/invitedChildInformation/',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
});
